import React from 'react';
import {PICKUP_WAITING, SHIPPING} from '../helpers/ApplicationHelper'
const EditIcon = (props) => {
    const { item, click } = props
    if (!item || (item && item.workflow_state === SHIPPING && item.bundle.workflow_state === PICKUP_WAITING)) {
        return null
    }

    return (
        <i className="edit-icon" onClick={(e)=>{
            e.stopPropagation()
            click()
        }}/>
    );
}

export default EditIcon;
